export { default } from './FaqCard';
export * from './FaqCard';
